import { createAction, props } from "@ngrx/store";
import { IAppAppearance } from "../../models/white-labeling.model";

export const loadWhiteLabeling = createAction(
  "[App Appearance] Load App Appearance",
  props<{ userId: string; orgId: string }>()
);

export const whiteLabelingSuccess = createAction(
  "[App Appearance] Load App Appearance Success",
  props<{ response: IAppAppearance }>()
);

export const whiteLabelingFailure = createAction(
  "[App Appearance] Load App Appearance Failure",
  props<{ error: string }>()
);
